module.exports = __webpack_public_path__ + "img/aproved.af293f67.svg";